import { render, staticRenderFns } from "./MyProtocol1.vue?vue&type=template&id=21d5bab6&scoped=true"
import script from "./MyProtocol1.vue?vue&type=script&lang=js"
export * from "./MyProtocol1.vue?vue&type=script&lang=js"
import style0 from "./MyProtocol1.vue?vue&type=style&index=0&id=21d5bab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d5bab6",
  null
  
)

export default component.exports